import React from 'react';
import { getPartialProductData } from '../data';
import ProductDetailsContext from '../ProductDetailsContext';
import { ProductPartialDataLoaderOptions, getInitialProductDetailsState } from '../types';
import useProductDetails from '../useProductDetails';

const loaderOptions: ProductPartialDataLoaderOptions = {
	initialState: getInitialProductDetailsState,
	dataLoaderFn: getPartialProductData,
};

/**
 * Custom provider for ProductDetailsContext.
 */
const ProductDetailsProvider = (props) => {
	const UseProductDetailsResult = useProductDetails({ loaderOptions });
	return (
		<ProductDetailsContext.Provider
			value={{ state: { ...UseProductDetailsResult.state }, actor: { ...UseProductDetailsResult.actor } }}
		>
			{props.children}
		</ProductDetailsContext.Provider>
	);
};

export { ProductDetailsProvider };
